import { put, takeLatest, call, all } from 'redux-saga/effects';
import axios from 'axios';
import { API_URL } from "../../../config";
import { SESSION_EXPIRED } from "../../../_utils/constants/Auth";
import {
  PRODUCT_PRICE_REQUEST,
  PRODUCT_PRICE_SUCCESS,
  PRODUCT_PRICE_FAILED,
  PRODUCT_PRICE_CREATE,
  PRODUCT_PRICE_CREATE_SUCCESS,
  PRODUCT_PRICE_CREATE_FAILED,
  PRODUCT_PRICE_DELETE,
  PRODUCT_PRICE_DELETE_SUCCESS,
  PRODUCT_PRICE_DELETE_FAILED,
  PRODUCT_PRICE_EDIT,
  PRODUCT_PRICE_EDIT_SUCCESS,
  PRODUCT_PRICE_EDIT_FAILED,
} from "../../../_utils/constants/ProductCatalog";


/*****
 * ProductPrice Actions
 */

function* fetchProductPrice({ token }) {
  try {
    const response = yield call(axios.get, `${API_URL}/Product/api/ProductPrice/GetAllProductPrice`, { headers: { Authorization: `Bearer ${token}` } });
    yield put({ type: PRODUCT_PRICE_SUCCESS, payload: response.data });
  } catch (error) {
    if (error && error.response && error.response.status && error.response.status === 401) {
      yield put({ type: SESSION_EXPIRED });
    } else {
      yield put({ type: PRODUCT_PRICE_FAILED, payload: error.response });
    }
  }
}

function* createProductPrice(action) {
  try {
    const response = yield call(
      axios.post,
      `${API_URL}/Product/api/ProductPrice/CreateProductPrice`,
      action.payload.data, {
      headers: {
        Authorization: `Bearer ${action.payload.token}`
      },
    }
    );
    yield put({
      type: PRODUCT_PRICE_CREATE_SUCCESS,
      payload: response.data
    });
  }
  catch (error) {
    if (error && error.response && error.response.status && error.response.status === 401) {
      yield put({ type: SESSION_EXPIRED });
    } else {
      yield put({
        type: PRODUCT_PRICE_CREATE_FAILED,
        payload: error.response
      });
    }
  }
}
function* editProductPrice(action) {
  try {
    const response = yield call(
      axios.post,
      `${API_URL}/Product/api/ProductPrice/UpdateProductPrice`,
      action.payload.data, {
      headers: {
        Authorization: `Bearer ${action.payload.token}`
      },
    }
    );
    yield put({
      type: PRODUCT_PRICE_EDIT_SUCCESS,
      payload: response.data
    });
  }
  catch (error) {
    if (error && error.response && error.response.status && error.response.status === 401) {
      yield put({ type: SESSION_EXPIRED });
    } else {
      yield put({
        type: PRODUCT_PRICE_EDIT_FAILED,
        payload: error.response
      });
    }
  }
}
function* deleteProductPrice(action) {
  try {
    const response = yield call(
      axios.delete,
      `${API_URL}/Product/api/ProductPrice/RemoveProductPrice?ProductPriceId=${encodeURIComponent(action.payload.ProductPriceId)}`, {
      headers: {
        Authorization: `Bearer ${action.payload.token}`
      }
    },
    );
    yield put({
      type: PRODUCT_PRICE_DELETE_SUCCESS,
      payload: response.data
    });
  }
  catch (error) {
    if (error && error.response && error.response.status && error.response.status === 401) {
      yield put({ type: SESSION_EXPIRED });
    } else {
      yield put({
        type: PRODUCT_PRICE_DELETE_FAILED,
        payload: error.response
      });
    }
  }
}



export default function* rootProductPriceList() {
  yield all([
    takeLatest(PRODUCT_PRICE_REQUEST, fetchProductPrice),
    takeLatest(PRODUCT_PRICE_CREATE, createProductPrice),
    takeLatest(PRODUCT_PRICE_DELETE, deleteProductPrice),
    takeLatest(PRODUCT_PRICE_EDIT, editProductPrice),
  ]);
}